export const MaxNumbersOfAttachments = 30;
export const CHUNCK_SIZE = 5;
export const NUMBER_OF_POSTS = 6;
export const NUMBER_OF_REQUESTS = 10;
export const NUMBER_OF_NOTIFICATIONS = 4;
export const DEFAULT_TIME = '09:00';
export const MAX_LENGHT_OF_BROKER_TITLE = 20;
export const MIN_LENGHT_OF_BROKER_TITLE = 3;
export const MAX_LENGHT_OF_BROKER_CODE = 20;
export const MARKETING_QUERY_KEY = 'AdId';